<template>
  <v-dialog v-model="articleCommentsDialog" width="750">
    <v-card flat>
      <v-card-title class="display-1 pb-12">{{item.Title}}</v-card-title>
      <div class="pa-3">
        <v-textarea :label="$t('yourArticles.commentDialog.Write an comment')" dense></v-textarea>
      </div>
      <v-card-text v-for="item in dummyShares" :key="item.sharerId">
        <div class="pl-5">
          <div style="display:flex;">
            <v-avatar v-if="item.image !== ''">
              <img :src="item.image" alt="X">
            </v-avatar>
            <v-avatar v-else color="grey">
              <v-icon>fas fa-user</v-icon>
            </v-avatar>
            <span class="pl-5 title">{{item.name}} </span>
            <span class="pl-3 subtitle-1">{{item.date}} </span>
            <v-spacer></v-spacer>
            <span class="pr-12">
              <v-menu offset-y>
                <template v-slot:activator="{ on }">
                  <v-btn icon color="primary" dark  v-on="on" :title="$t('yourArticles.commentDialog.Actions')">
                    <v-icon>fas fa-ellipsis-v</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item>
                    <v-btn color="error" block>{{$t('yourArticles.commentDialog.Report')}}</v-btn>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color="primary" block>{{$t('yourArticles.commentDialog.Hide')}}</v-btn>
                  </v-list-item>
                  <v-list-item>
                    <v-btn color="success" block>{{$t('yourArticles.commentDialog.Reply')}}</v-btn>
                  </v-list-item>
                </v-list>
              </v-menu>
            </span>
          </div>
          <v-row>
            <v-col md="10" class="mb-0 pb-0">
              <p class="subtitle-1">{{item.comment}}</p>
            </v-col>
          </v-row>
        </div>
        <v-divider></v-divider>
        <v-divider></v-divider>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="primary" @click="articleCommentsDialog = false">{{$t('yourArticles.commentDialog.Close')}}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import messages from "../../modules/lang/main/export";
  export default {
    i18n: { messages },
    data(){
      return{
        item:{},
        articleCommentsDialog: false,
        dummyShares:[
          {articleId:22, sharerId:66, name:"Bruce", date:"03 February 2020",sentFrom:"Phone", image:"", comment:"First!!"},
          {articleId:22, sharerId:33, name:"Bob", date:"01 February 2020", sentFrom:"Phone", image:"", comment:"Best Article ever! cant wait to go swimming with the dolphins in haiti.... They do have dolphins right?"},
          {articleId:22, sharerId:44, name:"Jane", date:"02 February 2020", sentFrom:"Phone", image:"", comment:"Supert Skrevet. Kan ikke vente med å dra dit"},
          {articleId:22, sharerId:123, name:"John", date:"01 February 2020", sentFrom:"Computer", image:"https://cdn.vuetifyjs.com/images/john.jpg",comment:"lOREM IPSUM HAITI STUFF STUFF.. Sorry caps.  Lorem Ipsum Haiti Stuff Stuff"},
          {articleId:22, sharerId:55, name:"Lisa", date:"03 February 2020", sentFrom:"Computer", image:"", comment:"Larem upsim"},
        ],
      }
    },
    methods: {
      openDialog(item) {
        this.item = item;
        this.articleCommentsDialog = true;
      },
    }
  }
</script>